module.exports = __webpack_public_path__ + "img/project3.021f91bb.jpg";